import { render, staticRenderFns } from "./MiddlePart.vue?vue&type=template&id=903b7bd4&"
import script from "./MiddlePart.vue?vue&type=script&lang=js&"
export * from "./MiddlePart.vue?vue&type=script&lang=js&"
import style0 from "./MiddlePart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports